import React, { memo, ReactElement, useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'

import { getterHash } from 'core/utils/helpers'
import history from 'core/history/history'
import { ID_SECURE_LAYOUT } from 'core/utils/constants'
import { FormMode } from 'shared/interfaces'

import { TFunctionalFormStepper } from './form-stepper.interfaces'

import styles from './FormStepper.module.scss'

const FunctionalFormStepper = ({ children, location, mode, className }: TFunctionalFormStepper): ReactElement => {
  const locationStep = getterHash(location)
  const [ title, setTitle ] = useState('')
  const handleChangeTitle = (currentTitle: string) => {
    if (currentTitle !== title) {
      setTitle(currentTitle)
    }
  }
  const [ step, setStep ] = useState(locationStep)
  useEffect(() => {
    const scrolledContainer = document.getElementById(ID_SECURE_LAYOUT)
    if (scrolledContainer) {
      scrolledContainer.scrollTop = 0
    }
    setStep(locationStep)
  }, [locationStep])

  useEffect(() => {
    if (step !== 1 && mode === FormMode.create) {
      history.push({
        pathname: location.pathname,
        hash: '1'
      })
    }
  }, [])
  return (
    <div className={className || styles.formWrap}>
      <p className={styles.formTitle}><Translate id={title} /></p>
      {children(handleChangeTitle, title, step)}
    </div>
  )
}

FunctionalFormStepper.displayName = 'FunctionalFormStepper'

export default memo(FunctionalFormStepper)
